const UPSELL_TRACKING_KEY = '@utMode';

export type UpsellTrackingData = {
  status: string;
  path: string;
  feature: string;
  eventId?: string;
  timestamp?: number;
};

export function trackUpsell(data: UpsellTrackingData): void {
  try {
    const body = {...data, timestamp: Math.round(new Date().getTime() / 1000)};
    window.sessionStorage.setItem(UPSELL_TRACKING_KEY, JSON.stringify(body));
  } catch (e) {
    evite.error('Failed to track upsell', e);
  }
}

const sendTrack = (body: UpsellTrackingData): void => {
  try {
    if (body.eventId) {
      const formData = new FormData();
      formData.append('event_id', body.eventId);
      formData.append('status', body.status);
      formData.append('path', body.path.replace(/^\//, ''));
      formData.append('feature', body.feature);
      formData.append('timestamp', `${body.timestamp}`);
      formData.append('csrfmiddlewaretoken', evite.cookie('csrftoken') as string);
      if (!navigator.sendBeacon('/_ct/upsell', formData)) {
        evite.error('Failed to send upsell tracking beacon', formData);
      }
    }
  } catch (e) {
    evite.error('Failed to send upsell track', e);
  }
};

export function sendUpsellTrack(eventId?: string): void {
  try {
    const data = window.sessionStorage.getItem(UPSELL_TRACKING_KEY);
    if (typeof data === 'string') {
      const body = JSON.parse(data);
      if (eventId) {
        body.eventId = eventId || body.eventId;
      }
      if (!body.timestamp) {
        body.timestamp = Math.round(new Date().getTime() / 1000);
      }
      if (body.eventId) {
        window.sessionStorage.removeItem(UPSELL_TRACKING_KEY);
      }
      sendTrack(body);
    }
  } catch (e) {
    evite.error('Failed to send upsell tracking', e);
  }
}
